import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter,
  ChangeDetectionStrategy
} from "@angular/core";
import { Subject, Subscription } from "rxjs";
import { debounceTime } from "rxjs/operators";

@Component({
  selector: "onsip-color-picker",
  templateUrl: "./color-picker.component.html",
  styleUrls: ["./color-picker.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ColorPickerComponent implements OnInit, OnDestroy, OnChanges {
  @Input() defaultColors: Array<string> = [];

  @Input() color = "";
  @Output() colorChange = new EventEmitter<string>();

  customColor = "";
  customColorPickerEvent = new Subject<string>();

  private unsubscriber = new Subscription();

  ngOnInit(): void {
    this.unsubscriber.add(
      this.customColorPickerEvent
        .pipe(debounceTime(500))
        .subscribe(color => this.toggleColorPicker(color))
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!this.defaultColors.includes(changes.color.currentValue)) {
      this.customColor = changes.color.currentValue;
    }
  }

  toggleColorPicker(value: string): void {
    if (!this.defaultColors.includes(value)) this.customColor = value;
    this.colorChange.emit(value);
  }

  ngOnDestroy() {
    this.unsubscriber.unsubscribe();
  }
}
